import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { FadeIn } from './FadeIn';
export function DesireSection() {
  const desires = ['Saber exactamente qué entra y qué sale', 'Pagar tus cuentas sin correr', 'Tener un plan para salir de deudas', 'Empezar un fondo de emergencia', 'Y sentir esa paz de: “ya lo tengo bajo control.”'];
  return <section className="py-20 relative" data-id="element-25">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-26">
        <FadeIn data-id="element-27">
          <div className="text-center mb-12" data-id="element-28">
            <p className="text-xl text-slate-400 mb-2" data-id="element-29">
              Lo que quieres no es "ser experta"
            </p>
            <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-30">
              Lo que quieres es:
            </h2>
          </div>
        </FadeIn>

        <div className="grid gap-4 mb-16" data-id="element-31">
          {desires.map((desire, index) => <FadeIn key={index} delay={index * 0.1} direction="left" data-id="element-32">
              <div className="flex items-center gap-4 p-4 rounded-lg hover:bg-white/5 transition-colors" data-id="element-33">
                <CheckCircle2Icon className="w-6 h-6 text-gold-500 flex-shrink-0" data-id="element-34" />
                <p className="text-lg md:text-xl text-slate-200 font-medium" data-id="element-35">
                  {desire}
                </p>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.5} data-id="element-36">
          <div className="text-center max-w-2xl mx-auto" data-id="element-37">
            <p className="text-xl md:text-2xl text-gold-400 font-heading tracking-wide leading-relaxed" data-id="element-38">
              Sin vivir contando centavos. Sin pelearte con tu pareja. Sin
              sentirte culpable cada vez que compras algo para ti.
            </p>
          </div>
        </FadeIn>
      </div>
    </section>;
}